'use client'

import { useState } from 'react'

import { Dialog, DialogContent, DialogTrigger } from '@/_components/ui/dialog'

import { HospitalIcon } from '../../../_components/icons'
import { Button, ButtonProps } from '../../../_components/ui/button'
import { BecomePartnerDialog } from './become-partner-dialog'

type BecomePartnerButtonProps = ButtonProps & {
  icon?: boolean
}

const BecomePartnerButton = ({ className, icon }: BecomePartnerButtonProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  return (
    <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <DialogTrigger asChild>
        <Button className={className}>
          {icon && <HospitalIcon />}
          Quero me tornar parceiro
        </Button>
      </DialogTrigger>

      <DialogContent className="w-[21rem] p-5">
        <BecomePartnerDialog setIsDialogOpen={setIsDialogOpen} />
      </DialogContent>
    </Dialog>
  )
}

export default BecomePartnerButton
